module.exports = __webpack_public_path__ + "static/media/zoomIn.ef3c2a98.svg";